// @ts-nocheck
import { Stack, Title, Text, SimpleGrid, Code } from '@mantine/core';
import { Card } from '../../../../components/ui';
import {
  CircularGauge,
  LinearGauge,
  SemiCircleGauge,
} from '../../../../components/advanced/Widgets';

export default function GaugeWidgetsPage() {
  return (
    <Stack gap="xl">
      <Stack gap="xs">
        <Title order={2}>Gauge / Progress Widgets</Title>
        <Text c="dimmed" size="sm">
          Display progress toward targets with circular, linear, and semi-circle gauge variants.
          Automatic color coding based on thresholds.
        </Text>
      </Stack>

      {/* Circular Gauge */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>CircularGauge</Title>
          <Text size="sm" c="dimmed">
            Ring progress indicator with threshold markers and automatic color coding.
          </Text>

          <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
            <CircularGauge
              title="Storage Usage"
              value={67}
              max={100}
              unit="%"
              description="2.3 TB of 3.5 TB used"
              size="md"
            />
            <CircularGauge
              title="CPU Utilization"
              value={42}
              max={100}
              unit="%"
              thresholds={[
                { value: 70, color: '#fa5252', label: 'Critical' },
                { value: 50, color: '#fab005', label: 'Warning' },
                { value: 0, color: '#40c057', label: 'Normal' },
              ]}
              size="md"
            />
            <CircularGauge
              title="Memory"
              value={85}
              max={100}
              unit="%"
              showPercentage
              showValue
              size="md"
            />
            <CircularGauge
              title="Bandwidth"
              value={1250}
              max={2000}
              unit=" GB"
              description="of monthly limit"
              size="md"
            />
          </SimpleGrid>

          <Code block>
{`<CircularGauge
  title="Storage Usage"
  value={67}
  max={100}
  unit="%"
  thresholds={[
    { value: 70, color: 'red', label: 'Critical' },
    { value: 30, color: 'green', label: 'Normal' }
  ]}
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Linear Gauge */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>LinearGauge</Title>
          <Text size="sm" c="dimmed">
            Horizontal progress bar with threshold markers and percentage display.
          </Text>

          <Stack gap="md">
            <LinearGauge
              title="Project Completion"
              value={67}
              max={100}
              unit="%"
              description="23 of 35 tasks completed"
              size="md"
            />
            <LinearGauge
              title="Budget Utilization"
              value={145000}
              max={200000}
              unit=" $"
              thresholds={[
                { value: 180000, color: '#fa5252' },
                { value: 160000, color: '#fab005' },
                { value: 0, color: '#40c057' },
              ]}
              size="md"
            />
            <LinearGauge
              title="Monthly Goal"
              value={8234}
              max={10000}
              description="Target: 10,000 users"
              size="lg"
            />
          </Stack>

          <Code block>
{`<LinearGauge
  title="Project Completion"
  value={67}
  max={100}
  unit="%"
  description="23 of 35 tasks completed"
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Semi-Circle Gauge */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>SemiCircleGauge</Title>
          <Text size="sm" c="dimmed">
            Speedometer-style semi-circle gauge for visual impact.
          </Text>

          <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
            <SemiCircleGauge
              title="Performance Score"
              value={87}
              max={100}
              unit="%"
              size="md"
            />
            <SemiCircleGauge
              title="Customer Satisfaction"
              value={4.6}
              max={5}
              unit="/5"
              size="md"
            />
            <SemiCircleGauge
              title="System Health"
              value={92}
              max={100}
              unit="%"
              thresholds={[
                { value: 80, color: '#40c057' },
                { value: 50, color: '#fab005' },
                { value: 0, color: '#fa5252' },
              ]}
              size="md"
            />
          </SimpleGrid>

          <Code block>
{`<SemiCircleGauge
  title="Performance Score"
  value={87}
  max={100}
  unit="%"
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Use Cases */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>Common Use Cases</Title>
          <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
            <Stack gap="xs">
              <Text size="sm" fw={500}>Resource Monitoring</Text>
              <Text size="xs" c="dimmed">
                Track system resources (CPU, memory, storage) with threshold alerts.
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text size="sm" fw={500}>Goal Tracking</Text>
              <Text size="xs" c="dimmed">
                Monitor progress toward business goals and targets.
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text size="sm" fw={500}>Budget Management</Text>
              <Text size="xs" c="dimmed">
                Display budget utilization with warning thresholds.
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text size="sm" fw={500}>Performance Metrics</Text>
              <Text size="xs" c="dimmed">
                Show satisfaction scores, health metrics, and KPI progress.
              </Text>
            </Stack>
          </SimpleGrid>
        </Stack>
      </Card>
    </Stack>
  );
}
